const VisitsPaths = {
  VisitsMain: "/Visits",
  VisitPage: "/Visits/Visit",
  NewVisit: "/Visits/NewVisit",
  FakeNewVisit: "/Visits/FakeNewVisit",
  NewVisitFinalPage: "/Visits/NewVisitFinal",
  IncompleteDocumentationPage: "/Visits/IncompleteDocumentation",
  SendToServerPage: "/Visits/SendToServer",
  VisitsEdit: "/Visits/Edit",
  DispatchPage :"/Visit/Dispatch",
  RefrencePage :"/Visit/Refrence"
};
export default VisitsPaths;
